import { render, staticRenderFns } from "./ChartsCard.vue?vue&type=template&id=271a5042&scoped=true"
import script from "./ChartsCard.vue?vue&type=script&lang=js"
export * from "./ChartsCard.vue?vue&type=script&lang=js"
import style0 from "./ChartsCard.vue?vue&type=style&index=0&id=271a5042&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a5042",
  null
  
)

export default component.exports